<div class="container mt-4 mb-4">
  <div class="card shadow-light border-0 rounded-5">
    <div class="card-body p-4 p-md-5">
      <h1 class="mb-4">{{ 'Legal notice' | t }}</h1>
      <p>
        Copyright by School of Life - Stephanie Coleman &amp; Christian von Saint Paul &copy;
      </p>
      <p>
        {{ 'Liability notice: Despite careful content checks, the operator assumes no liability for the content of external links. The operators of the linked pages are solely responsible for their content.' | t }}
      </p>
      <p class="mb-0">
        &copy; 2024 School of Life - {{ 'All rights reserved' | t }}
      </p>
    </div>
  </div>
</div>
